<template>
  <!-- <div class="img-message-wrap"  v-if="showBigImg" > -->
    <div id="floatImgs">
      <div class="img-message-wrap"  v-if="show">
        <div class="close-btn-wrap">
          <button @click.prevent="closeBig">
            <i class="el-icon-close"></i>
          </button>
          <!-- <button v-on:click.self.stop="closeBig()">
            <i class="el-icon-close"></i>
          </button> -->
        </div>
        <div class="page-up-wrap" v-show="imgs.length !==0">
          <button class="page-btn" @click.prevent="pageUp">
            <i class="el-icon-arrow-left"></i>
          </button>
        </div>
        <div class="container-wrap">
          <div class="img-wrap" v-for="(img,index) in imgs" :key="index" v-show="img.show">
            <img :src="img.src" alt="无法获取图片">
          </div>
        </div>

        <div class="page-down-wrap" v-show="imgs.length !==0">
          <button class="page-btn" @click.prevent="pageDn">
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
</template>

<script>
// import Bus from '@/bus.js'
// import {uploadFileApi} from '@/api/components/editAdmin.js'
function typeOf (obj) {
  const toString = Object.prototype.toString
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  return map[toString.call(obj)]
}
export default {
  name: 'imgFloatCarousel',
  // model: {
  //   prop: 'show',
  //   event: 'click'
  // },
  props: {
    imgsrc: {
      type: [String, Array],
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showBigImg: false, // 显示大图？
      imgs: [], // 图片数组
      index: 0 // 显示图片序列号
    }
  },
  methods: {
    /**
     * @description 关闭
     */
    closeBig () {
      // this.show = false
      this.$emit('update:show', false)
    },
    showBig () {
      // this.showBigImg = true
    },
    /**
     * @description 初始化图片数组
     */
    imgarr () {
      let arr = []
      let imgArr = []
      if (typeOf(this.imgsrc) === 'string') { // 接收到字符串url
        if (this.imgsrc !== '') {
          imgArr.push(this.imgsrc)
        }
      }
      if (typeOf(this.imgsrc) === 'array') { // // 接收到数组url
        arr = this.imgsrc
      }
      arr.forEach(item => { // 初始化图片显示
        let obj = {}
        obj.show = false
        obj.src = item
        imgArr.push(obj)
      })
      return imgArr
    },
    /**
     * @description 展示第一张图片
     */
    initImg () {
      if (this.imgs.length > 0) {
        this.imgs[0].show = true
      }
      this.index = 0
    },
    /**
     * @description 展示图片
     * @param {number} 显示第几张图片索引，从0开始
     */
    showImg (i) {
      this.imgs.forEach((item, index) => {
        if (index === i) {
          item.show = true
        } else {
          item.show = false
        }
      })
    },
    pageDn () {
      let len = this.imgs.length - 1

      if (this.index < len) {
        this.index++
        this.showImg(this.index)
      } else {
        this.index = 0
        this.showImg(this.index)
      }
      console.log('pageUp', this.imgs)
    },
    pageUp () {
      console.log('pageUp', this.imgs)
      if (this.index > 0) {
        this.index--
        this.showImg(this.index)
      } else {
        this.index = this.imgs.length - 1
        this.showImg(this.index)
      }
    }
  },
  mounted () {
    this.imgs = this.imgarr()
    this.initImg() // 展示第一张
  }
}
</script>

<style lang="scss" scoped>
.img-message-wrap{
  position: fixed;
  z-index: 9999999999999;
  // margin-top: 80px;
  top:50px;
  left: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 9999999999;
  width: calc(100% - 220px);
  height: calc(100% - 70px);
  background: rgba(0, 0, 0, 0.4);
  text-align: center;
  img{
    max-width: 144*5px;
    max-height: 105*5px;
  }
  .page-btn{
    border:none;
    background: transparent;
    color: #fff;
    font-size: 28px;
    height: 40px;
    width: 20px;
    cursor: pointer;
    outline: none;
    padding: 0;
  }
  .close-btn-wrap{
    position: absolute;
    top:20px;
    right: 20px;
    button{
      border:none;
      background: transparent;
      color: #fff;
      font-size: 24px;
      cursor: pointer;
      outline: none;
    }
  }
  .page-up-wrap{
    position: absolute;
    top:50%;
    left: 5%;
  }
  .page-down-wrap{
    position: absolute;
    top:50%;
    right: 5%;
  }
  .add-btn-wrap{
    margin: 0 auto;
    // position: absolute;
    // bottom:5%;
  }
  .container-wrap{
    max-width: 80%;
    max-height: 80%;
    margin: 0 auto;
  }
  .img-wrap{
    // max-width: 90%;
    // max-height: 90%;
    margin: 0 auto;
    display: inline-block;

  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/imgFloat.vue